import { useRef } from "react";
import EmojiPickerBg from "./EmojiPickerBg";

export default function ImagePreview({ user, text, setText, setError, images, setImages, setShowPreview }) {
    const imageInputRef = useRef(null);
    const handleImages = (e) => {
        let files = Array.from(e.target.files);
        files.forEach((img) => {
            if (img.type !== "image/jpeg" && img.type !== "image/png" && img.type !== "image/gif" && img.type !== "image/webp") {
                e.target.value = null;
                setError(`(${img.name}) Unsupported file type! Only .jpeg, .png, .gif, .webp file types are supported.`)
                files = files.filter(item => item.name !== img.name);
                return;
            }
            else if (img.size > 20971520) {
                e.target.value = null;
                setError(`(${img.name}) File size is not allowed! Max 20mb is allowed.`);
                files = files.filter(item => item.name !== img.name);
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(img);
            reader.onload = (readerEvent) => {
                setImages((images) => [...images, readerEvent.target.result])
            }
            setError("");
        })
    };

    return (
        <div className="overflow_a scrollbar">
            <EmojiPickerBg
                user={user}
                text={text}
                setText={setText}
                type2
            />
            <div className="add_pics_wrap">
                <input
                    type="file"
                    accept="image/jpeg, image/png, image/gif, image/webp"
                    multiple hidden
                    ref={imageInputRef}
                    onChange={handleImages}
                />
                {
                    images && images.length
                        ? (
                            <div className="add_pics_inside1 p0">
                                <div className="preview_actions">
                                    <button className="hover2"><i className="edit_icon"></i>Edit</button>
                                    <button className="hover2"
                                        onClick={() => {
                                            imageInputRef.current.click();
                                        }}
                                    >
                                        <i className="addPhoto_icon"></i>
                                        Add Images/Videos
                                    </button>
                                </div>
                                <div className="small_white_circle" onClick={() => { setImages([]) }}>
                                    <i className="exit_icon"></i>
                                </div>
                                <div className={
                                    images.length === 1
                                        ? "preview1"
                                        : images.length === 2
                                            ? "preview2"
                                            : images.length === 3
                                                ? "preview3"
                                                : images.length === 4
                                                    ? "preview4"
                                                    : images.length === 5
                                                        ? "preview5"
                                                        : images.length % 2 === 0
                                                            ? "preview_even"
                                                            : "preview_even preview_odd"
                                }>
                                    {images.map((img, i) => (
                                        <img src={img} key={i} alt="Post" />
                                    ))}
                                </div>
                            </div>
                        )
                        : (
                            <div className="add_pics_inside1">
                                <div className="small_white_circle" onClick={() => { setShowPreview(false) }}>
                                    <i className="exit_icon"></i>
                                </div>
                                <div className="add_col" onClick={() => {
                                    imageInputRef.current.click();
                                }}>
                                    <div className="add_circle">
                                        <i className="addPhoto_icon"></i>
                                    </div>
                                    <span>Add Images</span>
                                    <span>upto 20mb</span>
                                </div>
                            </div>
                        )
                }
                <div className="add_pics_inside2">
                    <div className="add_circle">
                        <i className="phone_icon"></i>
                    </div>
                    <div className="mobile_text">Add from your mobile device.</div>
                    <span className="addphone_btn" onClick={() => { imageInputRef.current.click() }}>Add</span>
                </div>
            </div>
        </div>
    )
}
